import { type HTMLInputTypeAttribute } from 'react';
import { isolateNumbers } from 'widget/actions';

const normalizeValue = (
  value: string,
  type: HTMLInputTypeAttribute,
): string => {
  if (type != 'tel') return value;

  const numbers = isolateNumbers(value);
  return numbers;
};

export { normalizeValue };
